export const getRandomElement = (elementsArray, lastColor) => {
    let filtered = elementsArray;
    if(!lastColor) {
        filtered = elementsArray.filter(item => item !== lastColor);
    }
    let random = Math.floor(Math.random() * filtered.length);
    return filtered[random];
};